import { Link } from '@material-ui/core';
import React from 'react';
import Markdown, { ReactMarkdownOptions } from 'react-markdown';

const COMPONENTS: { [key: string]: React.ComponentType<any> } = {
  root: React.Fragment,
  p: ({ children }) => (
    <span style={{ margin: 0, whiteSpace: 'pre-line', color: 'inherit' }}>
      {children}
    </span>
  ),
  a: props => (
    <Link
      {...props}
      target="_blank"
      rel="noreferrer noopener"
      component="a"
      style={{
        color: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        fontWeight: 'inherit',
        textDecorationLine: 'underline',
      }}
    />
  ),
};

const StyledMarkdown: React.FC<ReactMarkdownOptions> = ({
  components = {},
  ...props
}) => {
  return <Markdown components={{ ...COMPONENTS, ...components }} {...props} />;
};

export default StyledMarkdown;
